import { InputAdornment, InputBase } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import Debounce from '../../function/debounce';


const SearchBar = ({ onChange }) => {
    const debounceOnChange = useCallback(Debounce(onChange, 1000), []);
    const [search, setSearch] = useState('');
    return (
        <InputBase
            className={'py-1 px-2 f12-400'}
            style={{ borderRadius: '20px', boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff', minWidth: '280px' }}
            placeholder="Search"
            value={search}
            onChange={(e) => { setSearch(e.target.value); debounceOnChange(e.target.value) }}
            startAdornment={
                <InputAdornment position="start">
                    <SearchIcon style={{ color: "rgb(248, 80, 50)", fontSize: '18px' }} />
                </InputAdornment>
            }
            inputProps={{ 'aria-label': 'naked' }}
        />
    );
};

export default SearchBar;
